export default {
  bulkOptions: [
    {
      key: 'delete_bulk',
      field: 'delete_bulk',
      value: 'true',
      label: 'Delete',
      type: 'danger',
      permissionCode: 'notifications.delete_broadcast',
    },
  ],
  exportImportOptions: {
    export: {
      directly: true,
      url_name: 'api:admin:notifications:broadcast:export',
    },
  },
}